// extracted by mini-css-extract-plugin
export default {"categoriesDropdown":"CategoriesDropdown_categoriesDropdown__PtUUB"};